import type { TReminder } from '@src/shared/types/reminder';
import { Button } from '@src/design-system/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@src/design-system/tooltip';
import { RefreshLeftSquare } from 'iconsax-react';

import { CreateReminderDialog } from './create-reminder-dialog';

export function DuplicateBulkReminderButton({
  reminder,
}: {
  reminder: TReminder;
}) {
  return (
    <Tooltip>
      <CreateReminderDialog
        duplicateFrom={reminder}
        variant='bulk'
      >
        <TooltipTrigger asChild>
          <Button
            type='button'
            variant='ghost'
            size='iconSm'
            className='text-primary-1000'
            aria-label='Duplicate reminder'
          >
            <RefreshLeftSquare
              size={18}
              variant='TwoTone'
            />
          </Button>
        </TooltipTrigger>
      </CreateReminderDialog>
      <TooltipContent side='top'>Resend</TooltipContent>
    </Tooltip>
  );
}
